<template>
  <div class="x-data-view" style="margin-top: 0;">
    <!-- <div class="x-data-tool">
      <slot name="tool"></slot>
    </div> -->
    <div class="x-data-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'XDataNoTools'
  }
</script>

<style lang="scss">
  // @import '../../../common/assets/style/variables';

  .x-data-view {
    display: flex;
    flex: 1;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
    height: 0;
    margin-top: 10px;
    padding: 20px;
    border: 1px solid #ebebeb;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 5px 12px 12px 0 rgb(0 0 0 / 10%);

    .x-data-tool {
      display: flex;
      flex-direction: row;
      min-height: 30px;
      margin-bottom: 16px;

      > button {
        margin-right: 16px;
      }

      .tools {
        width: 100%;
      }

      .tools-config {
        text-align: right;
      }
    }

    .x-data-content {
      display: flex;
      overflow: hidden;
      flex: 1;
      flex-direction: column;
      height: 0;
    }
  }
</style>
